import styled from '@emotion/styled';
import KeyboardArrowLeftIcon from '@mui/icons-material//KeyboardArrowLeft';
import { AppBar, Button, IconButton, Toolbar, Typography } from '@mui/material';
import { BulkActionsAppBarProps } from './BulkActionsAppBar.props';

const StyledAppBar = styled(AppBar)({
  position: 'relative',
});

const StyledTitle = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  flex: 1,
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(1.5),
}));

const BulkActionsAppBar = ({
  onClose,
  onSave,
  isButtonDisabled,
  title,
  subtitle,
  actionLabel,
}: BulkActionsAppBarProps) => (
  <StyledAppBar color="transparent">
    <Toolbar>
      <StyledIconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
        <KeyboardArrowLeftIcon />
      </StyledIconButton>
      <span style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <StyledTitle variant="h6">{title}</StyledTitle>
        {subtitle ? <StyledTitle variant="subtitle1">{subtitle}</StyledTitle> : null}
      </span>
      <Button autoFocus variant="contained" color="secondary" onClick={onSave} disabled={isButtonDisabled}>
        {actionLabel}
      </Button>
    </Toolbar>
  </StyledAppBar>
);

export default BulkActionsAppBar;
